module.exports = __webpack_public_path__ + "954ed430462c652c44c304f0574aafc1.svg";